// NOTE Do not import like that it seems that then they are constants and the state is shared
// import { state, getters, actions, mutations } from '@shared/store/abstract-form.store';

import { Module } from 'vuex';

//  We can extends abstract state getters actions and muttations
//  For example:

const state = {
  ordersToCheckout: [],
  paymentMethod: null,
  checkoutResponse: null,
  publicLayoutQueryParams: {},
  // extends with new prop and methods here
};

const getters = {
  ordersToCheckout: (state): AnyEntity[] => {
    return state.ordersToCheckout || [];
  },
  paymentMethod: (state): string => {
    return state.paymentMethod || null;
  },
  checkoutResponse: (state): string => {
    return state.checkoutResponse || null;
  },
  totalPrice: (state): number => {
    let totalPrice = 0;
    state.ordersToCheckout.map(order => {
      totalPrice += order.total_price;
    });
    return totalPrice;
  },
  publicLayoutQueryParams: (state): any => {
    return state.publicLayoutQueryParams;
  },
};
const actions = {
  resetShoppingCart: async ({ commit, getters }): Promise<void> => {
    commit('setInitialState');
  },
  setOrdersToCheckout: async (
    { commit, getters },
    data: {
      ordersToCheckout: AnyEntity[];
    },
  ): Promise<void> => {
    console.log(commit, state, data);
    commit('setOrdersToCheckout', data.ordersToCheckout);
  },
  setPaymentMethod: async (
    { commit, getters },
    data: {
      paymentMethod: string;
    },
  ): Promise<void> => {
    console.log(commit, state, data);
    commit('setPaymentMethod', data.paymentMethod);
  },
  setCheckoutResponse: async (
    { commit, getters },
    data: {
      checkoutResponse: any;
    },
  ): Promise<void> => {
    console.log(commit, state, data);
    commit('setCheckoutResponse', data.checkoutResponse);
  },
};
const mutations = {
  setInitialState: (state): void => {
    // TODO implement initial state
    state.ordersToCheckout = [];
    state.paymentMethod = null;
  },

  addPublicLayoutQueryParams: (state, query): void => {
    state.publicLayoutQueryParams = query;
  },

  clearPublicLayoutQueryParams: (state): void => {
    state.publicLayoutQueryParams = {};
  },

  setOrdersToCheckout: (state, ordersToCheckout: AnyEntity): void => {
    state.ordersToCheckout = ordersToCheckout;
  },
  setPaymentMethod: (state, paymentMethod: string): void => {
    state.paymentMethod = paymentMethod;
  },
  setCheckoutResponse: (state, checkoutResponse: any): void => {
    state.checkoutResponse = checkoutResponse;
  },
};

export const ShoppingCartStoreModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
